// extracted by mini-css-extract-plugin
module.exports = {"content":"LimitEdit__content--njw","editMode":"LimitEdit__editMode--1Qx"};